export const laborStates = {
  rejected: { id: <0>0, label: 'ELEMENT.LABOR_STATE.REJECTED', name: 'rejected' },
  approved: { id: <1>1, label: 'ELEMENT.LABOR_STATE.APPROVED', name: 'approved' },
  waiting: { id: <2>2, label: 'ELEMENT.LABOR_STATE.WAITING', name: 'waiting' },
  additional: { id: <3>3, label: 'ELEMENT.LABOR_STATE.ADDITIONAL', name: 'additional' }
}

export type LaborState = typeof laborStates[keyof typeof laborStates];